import { useMemo } from 'react'
import { useApolloClient } from '@ts-gql/apollo'
import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client'

import { GRAPHQL_V2_VERSION_NUMBER } from '@scentregroup/shared/constants'
import localState from '@scentregroup/shared/local-state'
import withUserSettingsQuery from '@scentregroup/shared/containers/with-user-settings/query.graphql'

export type TSGQLApolloClient = ReturnType<typeof useApolloClient>

export function makeApolloClient(): TSGQLApolloClient {
  const v1Link = new HttpLink({
    uri: process.env.NEXT_PUBLIC_CONTENT_SERVICE, // Server URL (must be absolute)
    credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
  })
  const v2Link = new HttpLink({
    uri: process.env.NEXT_PUBLIC_CONTENT_SERVICE_V2, // Server URL (must be absolute)
    credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
  })
  const link = HttpLink.split(
    operation =>
      // this replicates the previous behaviour but removes lodash get
      // I'd probably got a bit further about how exactly this works later
      (operation.getContext().version || 1) === GRAPHQL_V2_VERSION_NUMBER,
    v2Link,
    v1Link
  )

  const cache = new InMemoryCache()

  const client = new ApolloClient({
    ssrMode: typeof window === 'undefined',
    link,
    cache,
    name: 'website-client',
    resolvers: localState.resolvers,
    typeDefs: localState.typeDefs,
  })

  cache.writeQuery({
    query: withUserSettingsQuery,
    data: localState.defaults,
  })

  // @ts-ignore
  return client
}

export function useApollo(): ReturnType<typeof makeApolloClient> {
  return useMemo(() => makeApolloClient(), [])
}
